import { render, staticRenderFns } from "./communityDialog.vue?vue&type=template&id=683e3f14&scoped=true&"
import script from "./communityDialog.vue?vue&type=script&lang=js&"
export * from "./communityDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683e3f14",
  null
  
)

export default component.exports